var map = {
	"./animal-1.svg": 900,
	"./animal-10.svg": 901,
	"./animal-11.svg": 902,
	"./animal-12.svg": 903,
	"./animal-13.svg": 904,
	"./animal-14.svg": 905,
	"./animal-15.svg": 906,
	"./animal-16.svg": 907,
	"./animal-17.svg": 908,
	"./animal-18.svg": 909,
	"./animal-19.svg": 910,
	"./animal-2.svg": 911,
	"./animal-20.svg": 912,
	"./animal-21.svg": 913,
	"./animal-22.svg": 914,
	"./animal-23.svg": 915,
	"./animal-24.svg": 916,
	"./animal-25.svg": 917,
	"./animal-26.svg": 918,
	"./animal-27.svg": 919,
	"./animal-28.svg": 920,
	"./animal-29.svg": 921,
	"./animal-3.svg": 922,
	"./animal-30.svg": 923,
	"./animal-31.svg": 924,
	"./animal-32.svg": 925,
	"./animal-33.svg": 926,
	"./animal-34.svg": 927,
	"./animal-35.svg": 928,
	"./animal-36.svg": 929,
	"./animal-37.svg": 930,
	"./animal-38.svg": 931,
	"./animal-39.svg": 932,
	"./animal-4.svg": 933,
	"./animal-40.svg": 934,
	"./animal-41.svg": 935,
	"./animal-42.svg": 936,
	"./animal-43.svg": 937,
	"./animal-44.svg": 938,
	"./animal-45.svg": 939,
	"./animal-46.svg": 940,
	"./animal-47.svg": 941,
	"./animal-48.svg": 942,
	"./animal-49.svg": 943,
	"./animal-5.svg": 944,
	"./animal-50.svg": 945,
	"./animal-6.svg": 946,
	"./animal-7.svg": 947,
	"./animal-8.svg": 948,
	"./animal-9.svg": 949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;